/* Toni Pons × Judge.me — lightweight pagination stability */
(function(){
  'use strict';

  function getOffset(){
    if(window.TPJudgeMe&&typeof window.TPJudgeMe.getStickyOffset==='function') return window.TPJudgeMe.getStickyOffset();
    return 0;
  }

  function signature(root){
    var active=root.querySelector('.jdgm-paginate__page.jdgm-curt');
    var first=root.querySelector('.jdgm-rev');
    return ((active&&active.textContent)||'')+'|'+((first&&first.textContent)||'').slice(0,80);
  }

  document.addEventListener('click',function(event){
    var target=event.target&&event.target.closest?event.target.closest('.jdgm-paginate__page'):null;
    if(!target) return;
    var root=target.closest('#judgeme_product_reviews,.jdgm-review-widget');
    if(!root) root=document.getElementById('judgeme_product_reviews');
    if(!root) return;

    var before=signature(root);
    var height=root.offsetHeight;
    var userInteracted=false;
    root.style.minHeight=height+'px';
    root.style.overflowAnchor='none';

    function markInteraction(){userInteracted=true;}
    window.addEventListener('wheel',markInteraction,{passive:true,once:true});
    window.addEventListener('touchstart',markInteraction,{passive:true,once:true});
    window.addEventListener('pointerdown',markInteraction,{passive:true,once:true});
    window.addEventListener('keydown',markInteraction,{once:true});

    var done=false;
    var timer;
    var mo=new MutationObserver(function(){
      if(signature(root)!==before) finish();
    });

    function finish(){
      if(done) return;
      done=true;
      mo.disconnect();
      window.clearTimeout(timer);
      window.requestAnimationFrame(function(){
        window.requestAnimationFrame(function(){
          root.style.removeProperty('min-height');
          root.style.removeProperty('overflow-anchor');
          if(userInteracted) return;
          var rect=root.getBoundingClientRect();
          var offset=getOffset()+12;
          if(rect.top<offset||rect.top>window.innerHeight*.55){
            window.scrollTo({top:Math.max(0,window.scrollY+rect.top-offset),behavior:'auto'});
          }
        });
      });
    }

    mo.observe(root,{childList:true,subtree:true});
    timer=window.setTimeout(finish,2500);
  },false);
})();
